import React from "react";
import { Flame } from "lucide-react";

export default function Hero({ onOpenCombo }) {
  return (
    <section className="relative overflow-hidden border-b border-border" data-testid="hero-section">
      <div
        className="absolute inset-0 opacity-20 mix-blend-overlay pointer-events-none"
        style={{
          backgroundImage: "url(https://images.pexels.com/photos/3122779/pexels-photo-3122779.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 grunge-noise pointer-events-none opacity-60" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-gold/60 text-gold font-heading uppercase tracking-[0.25em] text-sm">
            <Flame className="h-4 w-4" /> Made fresh. Loaded right.
          </div>
          <h1 className="mt-6 font-heading uppercase leading-[0.85] tracking-tight text-cream text-6xl sm:text-7xl lg:text-8xl">
            Loaded Food.<br />
            <span className="text-gold">Big Flavour.</span>
          </h1>
          <p className="mt-6 text-cream/80 text-lg max-w-xl">
            Hand-crafted pasta boxes, sticky street-style wings, and a combo deal that punches well
            above its price. Delivered hot to your door across <span className="text-gold">Partington · Carrington · Warburton</span>.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              onClick={onOpenCombo}
              className="btn-poster"
              data-testid="hero-build-combo-btn"
            >
              Build Your £12.99 Combo
            </button>
            <a href="#menu" className="btn-outline-poster" data-testid="hero-view-menu-btn">
              View Full Menu
            </a>
          </div>
          <p className="mt-4 text-xs text-cream/50 font-heading uppercase tracking-widest">
            £10 minimum order · £2 delivery
          </p>
        </div>
        <div className="lg:col-span-5 relative animate-fade-up" style={{ animationDelay: "120ms" }}>
          <div className="relative aspect-square">
            <div className="absolute inset-4 bg-gold/10 border border-gold/30" />
            <img
              src="/combo-image.png"
              alt="Pasta & Wings Combo"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="tape" />
            <div className="absolute -bottom-4 -right-4 bg-gold text-black font-heading text-3xl px-5 py-3 tracking-wider shadow-[6px_6px_0_0_#050505]">
              £12.99 COMBO
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
